/**
 * Formatting lives here, never in a component (UX-003 §6.2, UX-004 §4 rules).
 * Numbers, currency and dates come from the locale + the API fields — there is
 * no hardcoded currency symbol, unit or grouping anywhere.
 */
import { createContext, useContext, type ReactNode } from "react";

/** British English by default (UX-003 §6.1). Set per tenant/user via the provider. */
const DEFAULT_LOCALE = "en-GB";

const LocaleContext = createContext<string>(DEFAULT_LOCALE);

export function LocaleProvider(props: {
  locale?: string;
  children: ReactNode;
}): ReactNode {
  return (
    <LocaleContext.Provider value={props.locale ?? DEFAULT_LOCALE}>
      {props.children}
    </LocaleContext.Provider>
  );
}

export function useLocale(): string {
  return useContext(LocaleContext);
}

export function formatNumber(
  value: number,
  locale: string,
  opts?: Intl.NumberFormatOptions,
): string {
  return new Intl.NumberFormat(locale, opts).format(value);
}

/** Currency amount, with the symbol taken from the ISO code — never a literal. */
export function formatMoneyAmount(
  amount: number,
  currency: string,
  locale: string,
): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount);
}
